
class Wrapper {
    constructor(autoValidation = false) {
        this.callbacks = [];
        this.autoValidation = autoValidation;
    }

    updateModel(obj, callEvents = true) {
        this.model = Object.assign(this.model, obj);

        if(callEvents) this.callEvents();

        if(this.autoValidation)
        {
            this.validate();
        }
    }

    isValid() {}

    validate() {

    }

    addListener(cb) {
        this.callbacks.push(cb);
    }

    callEvents() {
        this.callbacks.forEach(cb => cb());
    }
}

module.exports = Wrapper;